<template>
  <div class="app-layout" :class="{'offline-mode' : offline}">
    <app-header />
    <transition name="fade" mode="out-in">
      <router-view class="main"></router-view>
    </transition>
    <fixed-steps />
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import FixedSteps from '@/components/FixedSteps.vue';

export default {
  components: {
    AppHeader,
    AppFooter,
    FixedSteps,
  },
  data () {
    return {
      offline: false
    }
  },
  beforeMount () {
    window.addEventListener('online', this.handleNetworkChange)
    window.addEventListener('offline', this.handleNetworkChange)
    this.handleNetworkChange()
  },
  methods: {
    handleNetworkChange () {
      if (navigator.onLine) {
        this.offline = false
      } else {
        this.offline = true
      }
    }
  }

}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
